import client from './client'
import type { User } from '@/types'

export const authApi = {
  async login(username: string, password: string) {
    const { data } = await client.post('/auth/login', { username, password })
    // API returns { success: true, data: { access_token, user, ... } }
    return data.data as { access_token: string; user: User }
  },

  async logout() {
    await client.post('/auth/logout')
  },

  async getProfile() {
    const { data } = await client.get('/auth/me')
    return data as User
  },

  async refreshToken() {
    const { data } = await client.post('/auth/refresh')
    return data.access_token as string
  }
}
